import { html } from 'lit';
import { App } from '@common/types/model';
import type { TefComs4p } from '@src/components/TefComs4p';

//
// renders a single app consent block
//
// {app name}
// {app consent status}
//
export const singleAppConsentEdit = function render(this: TefComs4p, app: App) {
  return html`
    <div class="form-row row" data-consent-id="${app.consentId}">
      <div class="form-group-checkbox" @click=${(e : PointerEvent) => { this.toggleAppConsent(e, app); }}>
        <input id="app-${app.id}" type="checkbox" ?checked="${app.granted}"></input>
        <label style="font-size: x-large" for="app-${app.id}">${app.name}</label>
      </div>
    </div>
  `;
};
